import type { ComponentPropsWithoutRef, ReactElement } from 'react'

import { components } from 'components/DefaultMdxComponents'
import type { Heading } from 'components/Heading'

import { extractElementText } from './extractElementText'
import { findElements } from './findElement'
import { getNavigationId } from './getNavigationId'

const headingTags = [components.h2, components.h3, components.h4, components.h5]
const firstTagLevel = 2

export const getHeadings = (element: ReactElement) =>
	findElements<ReactElement<ComponentPropsWithoutRef<typeof Heading> & { label: string }>>(element, ({ type }) =>
		headingTags.includes(type as any),
	).map(({ type, props }) => {
		const text = props.label ?? extractElementText(props.children)

		return {
			text,
			link: getNavigationId(text, props.prefix),
			level: headingTags.indexOf(type as any) + firstTagLevel,
		}
	})
